import { render, staticRenderFns } from "./InsuranceImportModal.vue?vue&type=template&id=c318caac&scoped=true"
import script from "./InsuranceImportModal.vue?vue&type=script&lang=js"
export * from "./InsuranceImportModal.vue?vue&type=script&lang=js"
import style0 from "./InsuranceImportModal.vue?vue&type=style&index=0&id=c318caac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c318caac",
  null
  
)

export default component.exports